import $ from "jquery";

$(document).on('turbolinks:load ready', function() {
    $(document).on('click', '.send-invitation', function(e) {
        $('#send_invitation').modal('show');
        $('.link-to-invite').attr('href', $(this).data('link'));
        e.preventDefault();
    });
});